const API_BASE = `${process.env.REACT_APP_API_URL}/api/data`;

async function fetchFromApi(endpoint) {
  const response = await fetch(`${API_BASE}${endpoint}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch ${endpoint}: ${response.statusText}`);
  }
  return response.json();
}

export async function loadPapers() {
  return await fetchFromApi("/papers");
}

export async function loadBlocks(paperId) {
  const endpoint = `/blocks/paper/${paperId}`;

  return await fetchFromApi(endpoint);
}

export async function loadImages() {
  return await fetchFromApi("/images");
}

export async function loadLists() {
  return await fetchFromApi("/lists");
}
